export default "__VITE_ASSET__BEUcBuHF__"